export function UserMealFormTabs({ activeTab, onTabChange, ingredientCount }) {
  return (
    <div className="flex bg-gray-100 rounded-xl p-1 mb-6">
      <button
        type="button"
        onClick={() => onTabChange("details")}
        className={`flex-1 py-2 text-sm font-medium rounded-lg transition-colors ${
          activeTab === "details"
            ? "bg-white text-gray-900 shadow-sm"
            : "text-gray-500 hover:text-gray-700"
        }`}
      >
        Details
      </button>
      <button
        type="button"
        onClick={() => onTabChange("ingredients")}
        className={`flex-1 py-2 text-sm font-medium rounded-lg transition-colors flex items-center justify-center gap-2 ${
          activeTab === "ingredients"
            ? "bg-white text-gray-900 shadow-sm"
            : "text-gray-500 hover:text-gray-700"
        }`}
      >
        Ingredients
        <span
          className={`text-xs font-medium px-1.5 py-0.5 rounded-full ${
            activeTab === "ingredients"
              ? "bg-gray-900 text-white"
              : "bg-gray-300 text-gray-600"
          }`}
        >
          {ingredientCount}
        </span>
      </button>
    </div>
  );
}
